// extracted by mini-css-extract-plugin
export default {"gallery-container":"Gallery_gallery-container__tuW2d","gallery":"Gallery_gallery__XojiD","swiper":"Gallery_swiper__e29kA","slide":"Gallery_slide__hMAv3","item":"Gallery_item__vlUpy"};